var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSzukaj(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .feather_een{fill:#a8a8a8;} "), /*#__PURE__*/React.createElement("path", {
    className: "feather_een",
    d: "M11,2c-4.963,0-9,4.037-9,9s4.037,9,9,9c4.963,0,9-4.037,9-9S15.963,2,11,2z M11,19 c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8S15.418,19,11,19z M21.293,18.707L21,19l-1.294-1.294 c1.735-2.25,2.632-5.179,2.176-8.332c-0.675-4.667-4.391-8.473-9.046-9.225C5.328-1.065-1.065,5.328,0.149,12.836 c0.752,4.655,4.558,8.371,9.225,9.046c3.153,0.456,6.083-0.441,8.332-2.176L19,21l-0.293,0.293c-0.39,0.391-0.39,1.024,0,1.414 L26,30c1.105,1.105,2.895,1.105,4,0l0,0c1.105-1.105,1.105-2.895,0-4l-7.293-7.293C22.317,18.317,21.683,18.317,21.293,18.707z M1,11C1,5.486,5.486,1,11,1c5.514,0,10,4.486,10,10s-4.486,10-10,10C5.486,21,1,16.514,1,11z M18.471,19.057 c0.203-0.188,0.398-0.383,0.586-0.586l1.236,1.236l-0.586,0.586L18.471,19.057z M19.395,21.98l2.598-2.573l7.3,7.3 c0.714,0.714,0.714,1.872,0,2.586l0,0c-0.714,0.714-1.872,0.714-2.586,0L19.395,21.98z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSzukaj);
export default __webpack_public_path__ + "static/media/szukaj.8ed43586e3fbf55cdbdde943648a7c65.svg";
export { ForwardRef as ReactComponent };